<div [formGroup]="boxCertificateForm" fxLayout="column">
  <div *ngIf="generalError" class="mat-error">
    {{generalError?.message}}
  </div>

  <mat-form-field>
    <mat-label>Creation Date </mat-label>

    <input formControlName="creationDate" (focusin)="creationDate.open()" readonly [matDatepicker]="creationDate"
      [max]="boxCertificateForm.controls['endDate']?.value" matInput name="creationDate">
    <mat-datepicker-toggle [for]="creationDate" matSuffix></mat-datepicker-toggle>
    <mat-datepicker-toggle matSuffix (click)="boxCertificateForm.controls.creationDate.setValue(null)">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #creationDate></mat-datepicker>

    <mat-error
      *ngIf="boxCertificateForm.controls.creationDate?.errors?.pattern && !boxCertificateForm.controls.creationDate?.errors?.required">
      Please enter a valid creation date
    </mat-error>
    <mat-error *ngIf="boxCertificateForm.controls.creationDate?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>End Date </mat-label>

    <input formControlName="endDate" matInput name="creationDate" [matDatepicker]="endDate" readonly
      (focusin)="endDate.open()" [min]="boxCertificateForm.controls['creationDate']?.value">
    <mat-datepicker-toggle [for]="endDate" matSuffix></mat-datepicker-toggle>
    <mat-datepicker-toggle matSuffix (click)="boxCertificateForm.controls.endDate.setValue(null)">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #endDate></mat-datepicker>


    <mat-error
      *ngIf="boxCertificateForm.controls.endDate?.errors?.pattern && !boxCertificateForm.controls.endDate?.errors?.required">
      Please enter a valid end date
    </mat-error>
    <mat-error *ngIf="boxCertificateForm.controls.endDate?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <ng-container *ngIf="!isEditing">
    <mat-form-field>
      <mat-label>Box</mat-label>
      <mat-select [(value)]="selectedBox" [disabled]="isEditing" formControlName="box" name="box">
        <mat-option *ngIf="!loadingBoxes && boxes.length === 0">
          No boxes available.
        </mat-option>
        <mat-option *ngFor="let box of boxes" [value]="box">
          {{box.identifier}}
        </mat-option>
      </mat-select>
      <span *ngIf="loadingBoxes" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
      <mat-hint *ngIf="!loadingBoxes && boxes.length === 0" class="color-warn">
        No boxes available.
      </mat-hint>
    </mat-form-field>
  </ng-container>

  <mat-form-field>
    <mat-label>cmId </mat-label>
    <input formControlName="cmId" matInput name="cmId" type="text">
    <mat-error *ngIf="boxCertificateForm.controls.cmId?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="certificate = _certificate; canceled.emit()" mat-button>Cancel</button>
    <button (click)="saveBoxCertificate()" [disabled]="boxCertificateForm.invalid || saving " color="primary"
      mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>